<mat-spinner *ngIf="loading" class="spinner" color="warn"></mat-spinner>
<router-outlet></router-outlet>
